import Head from "layout/head/Head"
import { UICard, UIContent, UIDataTable, UIPageTitle } from "components"
import { useViewModel } from "./StoreListViewModel"

const StoreListView = () =>
{
    const viewModel = useViewModel()
    
    return (
        <>
            <Head title="storePageTitle" />

            <UIContent>
                <UIPageTitle title="storePageTitle" description="storePageDescription" />
                <UICard>
                    <UIDataTable columns={viewModel.storeColumns} data={viewModel.storesData} isLoading={viewModel.isLoading} onPageChange={viewModel.setPaging} paging={viewModel.paging} />
                </UICard>
            </UIContent>
        </>
    )
}

export default StoreListView
